type SpecialtyItem = {
	vid_V?: string;
	id?: string;
};

export const resolveLocalSpec = (
	allSpecLocal: SpecialtyItem[] | undefined,
	index: number,
	prevCode: string | null | undefined,
	getId: (s: SpecialtyItem) => string | undefined
): string | null | undefined => {
	if (allSpecLocal === undefined) return undefined;
	const next = getId(allSpecLocal[index] ?? {});
	return next !== prevCode ? (next ? next : null) : undefined;
};
